import { createTranslations } from '@/i18n/types';

/**
 * One source of truth for every "log in to continue" wall in
 * (auth)/. Page wrappers pass `screen={'profile'|'upgrade'|...}`
 * and RequiresLogin looks the title/reason up here.
 */
export default createTranslations({
  en: {
    login: 'Log in',
    profileTitle: 'Profile',
    profileReason: 'Log in to view your profile, balance, statistics and activity history.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Log in to upgrade your skins. Pick your skin and try to get a more valuable one.',
    contractsTitle: 'Contracts',
    contractsReason: 'Log in to exchange several of your items for a single new one. The more your items are worth, the higher the contract stake.',
    inventoryTitle: 'Inventory',
    inventoryReason: 'Log in to see your skins. Sell, withdraw to Steam, send to upgrade or contracts.',
    referralsTitle: 'Friends',
    referralsReason: 'Log in to invite friends and earn a share of their drops. Your referral link will appear here.',
    paymentTitle: 'Top up balance',
    paymentReason: 'Log in to top up your SHOT balance and unlock case opening, contracts and upgrades.',
    caseOpenTitle: 'Open the case',
    caseOpenReason: 'Log in to open cases. Your won items go straight to your inventory.',
    caseBattleCreateTitle: 'Create a case battle',
    caseBattleCreateReason: 'Log in to challenge friends to a case battle. Stake your coins, the highest drop wins everything.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Log in to play Rush Mid — turn-based PvP matches against players on the same ticket.',
    rushMidSurveyTitle: 'Rush Mid survey',
    rushMidSurveyReason: 'Log in to take the Rush Mid survey and help make the game better.',
    rouletteTitle: 'Roulette',
    rouletteReason: 'Log in to play roulette — one round, one bank, the odds are equal for everyone.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Log in to join SHOT BAND — a members club with cashback, daily quests and a weekly knife raffle.',
  },
  ru: {
    login: 'Войти',
    profileTitle: 'Профиль',
    profileReason: 'Войди, чтобы посмотреть свой профиль, баланс, статистику и историю активности.',
    upgradeTitle: 'Апгрейд',
    upgradeReason: 'Войди, чтобы прокачивать свои предметы. Выбери свой скин и попробуй получить более ценный.',
    contractsTitle: 'Контракты',
    contractsReason: 'Войди, чтобы обменивать несколько своих предметов на один новый. Чем дороже сумма твоих предметов — тем выше ставка контракта.',
    inventoryTitle: 'Инвентарь',
    inventoryReason: 'Войди, чтобы посмотреть свои скины. Продавай, выводи в Steam, отправляй в апгрейд или контракты.',
    referralsTitle: 'Друзья',
    referralsReason: 'Войди, чтобы приглашать друзей и получать долю с их выпадений. Здесь появится твоя реферальная ссылка.',
    paymentTitle: 'Пополнение баланса',
    paymentReason: 'Войди, чтобы пополнить баланс SHOT и открывать кейсы, контракты, апгрейды.',
    caseOpenTitle: 'Открыть кейс',
    caseOpenReason: 'Войди, чтобы открывать кейсы. Выигранные предметы сразу попадут в твой инвентарь.',
    caseBattleCreateTitle: 'Создать кейс-баттл',
    caseBattleCreateReason: 'Войди, чтобы вызвать друзей на кейс-баттл. Ставь монеты, самый дорогой дроп забирает всё.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Войди, чтобы играть в Rush Mid — пошаговые PvP-матчи с игроками на том же билете.',
    rushMidSurveyTitle: 'Опрос по Rush Mid',
    rushMidSurveyReason: 'Войди, чтобы пройти опрос по Rush Mid и помочь сделать игру лучше.',
    rouletteTitle: 'Рулетка',
    rouletteReason: 'Войди, чтобы играть в рулетку — один раунд, один банк, шансы у всех равны.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Войди, чтобы вступить в SHOT BAND — клуб с кешбэком, ежедневными заданиями и еженедельным розыгрышем ножа.',
  },
  uz: {
    login: 'Kirish',
    profileTitle: 'Profil',
    profileReason: 'Profilingiz, balansingiz, statistikangiz va faollik tarixini koʻrish uchun kiring.',
    upgradeTitle: 'Apgreyd',
    upgradeReason: 'Skinlaringizni apgreyd qilish uchun kiring. Skiningizni tanlab, qimmatroq skinni olishga urining.',
    contractsTitle: 'Kontraktlar',
    contractsReason: 'Bir nechta predmetingizni bittasiga almashtirish uchun kiring. Predmetlar qiymati qancha yuqori boʻlsa, kontrakt stavkasi shuncha yuqori boʻladi.',
    inventoryTitle: 'Inventar',
    inventoryReason: 'Skinlaringizni koʻrish uchun kiring. Sotib, Steamga chiqarib, apgreyd yoki kontraktlarga yuboring.',
    referralsTitle: 'Doʻstlar',
    referralsReason: 'Doʻstlarni taklif qilish va ularning yutuqlaridan ulush olish uchun kiring. Sizning referal havolangiz shu yerda paydo boʻladi.',
    paymentTitle: 'Balansni toʻldirish',
    paymentReason: 'SHOT balansingizni toʻldirib, keyslar ochish, kontraktlar va apgreyd uchun kiring.',
    caseOpenTitle: 'Keysni ochish',
    caseOpenReason: 'Keyslarni ochish uchun kiring. Yutib olingan predmetlar darhol inventaringizga tushadi.',
    caseBattleCreateTitle: 'Keys jang yaratish',
    caseBattleCreateReason: 'Doʻstlaringizni keys jangiga chaqirish uchun kiring. Tangalaringizni tikib, eng qimmat drop hammasini oladi.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Rush Mid oʻynash uchun kiring — bir xil biletli oʻyinchilarga qarshi navbatma-navbat PvP matchlar.',
    rushMidSurveyTitle: 'Rush Mid soʻrovnomasi',
    rushMidSurveyReason: 'Rush Mid soʻrovnomasini toʻldirish va oʻyinni yaxshilashga yordam berish uchun kiring.',
    rouletteTitle: 'Ruletka',
    rouletteReason: 'Ruletka oʻynash uchun kiring — bitta raund, bitta bank, imkoniyatlar hamma uchun teng.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Keshbek, kunlik topshiriqlar va haftalik pichoq lotereyasi bilan SHOT BAND klubiga qoʻshilish uchun kiring.',
  },
});
